import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { loaderFade } from './loader.animation';

/**
 * LoaderComponent
 */
@Component({
  selector: 'ecp-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  animations: [loaderFade],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LoaderComponent {
  @HostBinding('class.loader') loader = true;
  /**
   * animate
   * @type {boolean}
   */
  @HostBinding('@loaderFade') animate = true;
  /**
   * backdrop
   * @type {boolean}
   */
  @Input() backdrop = true;

  @HostBinding('class.fluid')
  /**
   * fluid
   */
  @Input()
  fluid = true;
}
